import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { SsoCallback } from '@codespeak11/cognito-passwordless';

export default function SsoCallbackPage() {
  const navigate = useNavigate();

  return (
    <SsoCallback
      onSuccess={(returnPath) => navigate(returnPath, { replace: true })}
      onLoginRequired={() => navigate('/login', { replace: true })}
      onError={(err) => {
        console.error('[personawiz] SSO callback error:', err);
        navigate('/login', { replace: true });
      }}
    >
      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
        <Typography variant="body1" color="text.secondary" mt={2}>
          Signing in&hellip;
        </Typography>
      </Box>
    </SsoCallback>
  );
}
